<div [class.metabet-bubble]="environment.optionalFeatures.includes('metabet-bubbles')" [innerHtml]="content"></div>
